
export const Corner = {
    NE: 0,
    NW: 1,
    SE: 2,
    SW: 3,
}


export const WindowState = {
    NORMAL: 0,
    MINIMIZED: 1,
    MAXIMIZED: 2,
}